import React from 'react';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { Filters } from './types';

export const options = [
  { label: 'Contact', value: 'Backoffice::Contact' },
  { label: 'Deal', value: 'Apex::Deal' },
  { label: 'Listing', value: 'Project' },
  { label: 'Property', value: 'Research::Property' },
];

type Slice = Pick<Filters, 'parentTypes'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function ParentTypeFilter({ parentTypes, onChange }: Props) {
  return (
    <CheckboxFilter
      addFilter={(_name, filter) => onChange({ parentTypes: [...parentTypes, filter] })}
      hideClearControl={!parentTypes.length}
      hideSelectedCount={!parentTypes.length}
      label="Source"
      options={options}
      removeFilter={(_name, filter) => onChange({ parentTypes: parentTypes.filter(t => t !== filter) })}
      selected={parentTypes}
      onClear={() => onChange({ parentTypes: [] })}
    />
  );
}
